import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FilterExpenseStatusPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'filterExpenseStatus',
})
export class FilterExpenseStatusPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: any[], status) {
    // filter items array, items which match and return true will be kept, false will be filtered out
       
       //return items.filter(item => item.lastname.indexOf(args['lastname']) !== -1);
       //var r = new RegExp(status, 'i');

       var stat =  JSON.parse(status);
       return value.filter(item => item.Status == stat);

    //return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/filter-expense-status/filter-expense-status.ts